import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Rise, Words } from "../components/Reveal";
import { QuadernoRow } from "../components/QuadernoRow";
import { COPY } from "../content/copy";
import { fetchPosts } from "../lib/api";

export default function Quaderni() {
    const q = COPY.quaderni;
    const [posts, setPosts] = useState(null);

    useEffect(() => {
        fetchPosts(3)
            .then((p) => setPosts(p.length ? p : q.items))
            .catch(() => setPosts(q.items));
    }, [q.items]);

    return (
        <section className="section" data-testid="quaderni-block">
            <div className="container">
                <Rise>
                    <p className="caption">{q.caption}</p>
                </Rise>
                <Rise delay={0.05}>
                    <h2 className="h2 section-title" data-testid="quaderni-title">
                        <Words text={q.titleA} />{" "}
                        <Words text={q.titleB} italic />
                    </h2>
                </Rise>
                <Rise delay={0.1}>
                    <p className="lead section-lead">{q.lead}</p>
                </Rise>
                <div className="quaderni-list" data-testid="quaderni-list">
                    {(posts || []).map((item, i) => (
                        <Rise key={item.slug || item.title} delay={i * 0.06}>
                            <QuadernoRow
                                post={item}
                                index={i}
                                testId={`quaderno-row-${i}`}
                            />
                        </Rise>
                    ))}
                </div>
                <Rise>
                    <Link
                        className="tlink quaderni-all"
                        to="/quaderni"
                        data-testid="quaderni-all-link"
                    >
                        {q.all}
                    </Link>
                </Rise>
            </div>
        </section>
    );
}
